import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Button,  Label,  Container, Spinner, Modal, ModalHeader, ModalBody, } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import Select from "react-select";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { Link } from "react-router-dom";
import axios from "axios";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class AddPricing extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 4, 'create' )){
      this.props.history.push('/activities')
    }
    this.state = {
      loading: false,
      loadingstate: false,
      grouploading:false,
      model_type:false,
      groupCount:1,

      SelectedGroups: [],
      TypeGroup:[],


      breadcrumbItems: [
        { title: "Activities", link: "/activities" },
        { title: "Add Activity Pricing", link: "#" },
      ],
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
	

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleActivityTypeSubmit = this.handleActivityTypeSubmit.bind(this)
    this.handleselectedGroup = this.handleselectedGroup.bind(this);
    this.addGroupInput = this.addGroupInput.bind(this)
    this.removeGroupInput = this.removeGroupInput.bind(this)
    this.tog_type = this.tog_type.bind(this);

  }


  tog_type() {
    this.setState(prevState => ({
      model_type: !prevState.model_type
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  addGroupInput(){
    const {groupCount} = this.state
    this.setState({groupCount:groupCount+1})

  }
  removeGroupInput(){
    const {groupCount, SelectedGroups} = this.state
    let newdata = SelectedGroups
    let poped = newdata.pop()
    this.setState({groupCount:groupCount-1, SelectedGroups: newdata })
  }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/activities')
  }

  async componentDidMount() {
    await this.loadGroupsData()
 }
  async loadGroupsData(){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/activities/persons_group/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(group => {
                  let lable = group.max_person ===1?`Per Person`:`${group.min_person} - ${group.max_person} Person`
                  options.push({ label: lable, value: group.id })
                })
              
                let TypeGroup = [
                  { 
                    label: "TypeGroup",
                    options: options
                  }
                ];
                this.setState({ TypeGroup: TypeGroup })           
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }

  async loadActivityData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/activities/persons_group/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              
              this.setState({ activity: data })           
              
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
  }
  

  handleselectedGroup = (selectedGroup, index) =>{

    const {SelectedGroups } = this.state
    
    if(SelectedGroups.includes(selectedGroup.value) && SelectedGroups[index] !== selectedGroup.value){
      toastr.error(`${selectedGroup.label} already selected`,"")
    }
    else{
      
      let newdata = SelectedGroups
      let value = selectedGroup.value
      if ((newdata.length)-1 < index){
        newdata.push(value)
      }else{
          newdata[index] = value
      }
      
      this.setState({ SelectedGroups:newdata })
  }
  console.log(this.state.SelectedGroups, '------------')
}
handleActivityTypeSubmit(e, values){
  this.setState({ grouploading: true })
  axios.post(
    `${BaseUrl}/api/activities/persons_group/`,
    values,
    {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                   
    }
  ).then(res => {
    toastr.success(`Group ${res.min_person} - ${res.max_person} Added`,"") 
    this.loadGroupsData()
    this.setState({model_type:false, grouploading:false })

  }).catch(err => {
    console.log(err, "----------------------error");
    })
}

handleSubmit(e, values) {
  const id =this.props.match.params.id
  this.setState({ loading: true })
  const {SelectedGroups} = this.state
  let pricing = []
  let on_season_price = []
  for(let i=0; i<SelectedGroups.length;  i++){
    let index = i+"-price"
    let price = document.getElementById(`${index}`).value
    pricing.push(price)
    on_season_price.push(document.getElementById(`${i}-on_season_price`).value)
  }
  let group_pricing_data = {}
  group_pricing_data['activity'] = id
  group_pricing_data['group'] = SelectedGroups
  group_pricing_data['price'] = pricing
  group_pricing_data['on_season_price'] = on_season_price
  axios.post(
    `${BaseUrl}/api/activities/add_group_pricing/`,
    group_pricing_data,
      {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                    
      }
    )
    .then(res => {
      let pricing_data = {}
      pricing_data['activity'] = id
      pricing_data['distance'] = values.distance
      pricing_data['duration'] = values.duration
      pricing_data['group_pricing'] = res.data

      axios.post(
        `${BaseUrl}/api/activities/pricing/`,
          pricing_data,
          {
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                 
          }
        )
        .then(res => {
            toastr.success(`Pricing Added Successfully`,"")
            this.setState({ loading: false,  }) 
        })
        .catch(err => {
          toastr.error(`Somthing Went Wrong`,"") 
          this.setState({ loading: false, groupCount:1, SelectedGroups:[] })
            console.log(err, "----------------------error");
        })
    })
    .catch(err => {
      toastr.error(`Somthing Went Wrong`,"") 
      this.setState({ loading: false })
        console.log(err, "----------------------error");
    })

  }

  render() {
    const { TypeGroup } = this.state

    const PersonsGroups = ({ innerRef, innerProps, isDisabled, children }) =>
    !isDisabled ? (
        <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
            {children}
            <Link to="#" onClick={this.tog_type}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
        </div>
    ) : null;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Add New Activity" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" enctype="multipart/form-data" onValidSubmit={this.handleSubmit} >
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <h4 className="card-title">Activity Pricing</h4>

                          <Row>  
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label " htmlFor="distance">Distance (KM)</Label>
                                    <AvField
                                    name="distance"
                                    placeholder="Distance"
                                    type="text"
                                    errorMessage="Enter Distance"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="distance"
                                    
                                    />
                                </div>
                            </Col> 
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label " htmlFor="duration">Time Duration (Hours)</Label>
                                    <AvField
                                    name="duration"
                                    placeholder="Duration"
                                    type="text"
                                    errorMessage="Enter Duration"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="duration"
                                    
                                    />
                                </div>
                            </Col> 
                            </Row> 
      
                            {Array.from(Array(this.state.groupCount)).map((c,  index)=> {
                          return (
                                <Row>
                                    <Col md="4">
                                        <div className="mb-3">
                                            <Label className="form-label">Group</Label>
                                            <Select 
                                            onChange={(e) => this.handleselectedGroup(e, index)}
                                            options={TypeGroup}
                                            components={{ Menu: PersonsGroups }}
                                            classNamePrefix="select2-selection"
                                            />

                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="mb-3">
                                        <Label className="form-label " htmlFor={`${index}-price`}>Off Season Price</Label>
                                        <AvField
                                            name="group_price"
                                            placeholder="Off Season Group Price"
                                            type="number"
                                            className="form-control"
                                            errorMessage="Enter Only Number"
                                            validate={{
                                            required: { value: true },
                                                pattern: {
                                                value: "^[0-9]+$",
                                                errorMessage: "Only Numbers"
                                                }
                                            }}
                                            id={`${index}-price`}
                                        />
                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="mb-3">
                                        <Label className="form-label " htmlFor={`${index}-price`}>On Season Price</Label>
                                        <AvField
                                            name="on_season_price"
                                            placeholder="Off Season Group Price"
                                            type="number"
                                            className="form-control"
                                            errorMessage="Enter Only Number"
                                            validate={{
                                            required: { value: true },
                                                pattern: {
                                                value: "^[0-9]+$",
                                                errorMessage: "Only Numbers"
                                                }
                                            }}
                                            id={`${index}-on_season_price`}
                                        />
                                        </div>
                                    </Col>
                                </Row>
                                 )
                                })}
                                <Button className="btn-sm" type="button" onClick={this.addGroupInput} color="info"><i className=" fas fa-plus"></i></Button>
                                {" "}
                                {this.state.groupCount >1 ? <Button type="button" className="btn-sm" onClick={this.removeGroupInput} color="danger"><i className=" fas fa-minus"></i></Button>
                                :""}
                           

                  
                       


                                        
                        <FormGroup className="mb-1 mt-3">
                          {this.state.loading?(
                            <Spinner className="me-2 mt-2" color="primary" />
                          ):(
                            <div>
                        
                          <Button type="submit" color="primary" className="me-1">
                            Submit
                        </Button>{" "}
                        
                        </div>
                          )}
                        
                        
                      </FormGroup>      

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>
            <Row>
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_type}
                 toggle={this.tog_type}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_type: false })}>
                 Add Group
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleActivityTypeSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="min_person">Min</Label>
                           <AvField
                              name="min_person"
                              placeholder="Minimum Person"
                              type="number"
                              className="form-control"
                              errorMessage="Enter Only Number"
                              validate={{
                              required: { value: true },
                                  pattern: {
                                  value: "^[0-9]+$",
                                  errorMessage: "Only Numbers"
                                  }
                              }}
                              id="min_person"
                          />
                         </div>
                       </Col> 
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="max_person"> Max</Label>
                           <AvField
                              name="max_person"
                              placeholder="Maximum Person"
                              type="number"
                              className="form-control"
                              errorMessage="Enter Only Number"
                              validate={{
                              required: { value: true },
                                  pattern: {
                                  value: "^[0-9]+$",
                                  errorMessage: "Only Numbers"
                                  }
                              }}
                              id="max_person"
                          />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.grouploading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
            </Row>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AddPricing;
